var publicPath = __webpack_public_path__;
                    var symbolUrl = 'svg/global.svg#sound';
                    var viewUrl = 'svg/global.svg#view-sound';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 12 12',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };